export type AccountCategorySearchParams = {
  filter: {
    status: number;
    searchText: string;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type AccountTypesType = { accountType: number, accountName: string }

export type AccountcategoryTableDataType = {
  clinicId?: number;
  createdByUserId?: number;
  categoryId: number;
  createdDate?: string;
  accountType?: number;
  categoryStatus?: number;
  categoryName: string;
  categoryCode?: string;
};

export type MasterDataType = {
  categoryId: number|null;
  categoryName: string;
  categoryCode: string;
  accountType: number;
  categoryStatus: number;
  createdByUserId: number;
  clinicId: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  categoryName: string;
  categoryCode: string;
  accountType: AccountTypesType | null;
  categoryStatus: number;
};

export const initialFormData: MasterFormDataType = {
  categoryName: "",
  categoryCode: "",
  accountType: null,
  categoryStatus: 0,
};
